var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4737 -5.88953e-07L5.89474 -2.57667e-07L4.21053 5.89474L2.57667e-07 5.89474L5.88954e-07 13.4737L2.52632 13.4737C2.52632 14.8689 3.65739 16 5.05263 16C6.44788 16 7.57895 14.8689 7.57895 13.4737L12.6316 13.4737C12.6316 14.8689 13.7626 16 15.1579 16C16.5531 16 17.6842 14.8689 17.6842 13.4737L18.5263 13.4737C18.5263 14.8689 19.6574 16 21.0526 16C22.4479 16 23.5789 14.8689 23.5789 13.4737L25.2632 13.4737L24.3563 10.9474L21.0526 10.9474L15.1579 10.9474L13.4737 10.9474L13.4737 5.89474L13.4737 -5.88953e-07Z",
    fill: "#155878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckHead);
export default __webpack_public_path__ + "static/media/TruckHead.12a3b105ced8a87f91827da21a934927.svg";
export { ForwardRef as ReactComponent };